// Api endpoints
import {
    CANCEL_SUBSCRIPTION,
    CANCEL_SUBSCRIPTION_CANCELLATION,
    CANCEL_SUBSCRIPTION_DOWNGRADE
} from '@/lib/routes/apiEndpoints';

export const subscriptionStates = {
    default: {
        title: 'settings:subscription_invoices_page.cancel_subscription',
        modalText: 'settings:subscription_invoices_page.cancel_subscription_confirmation',
        apiEndpoint: CANCEL_SUBSCRIPTION
    },
    is_waiting_for_cancel: {
        title: 'settings:subscription_invoices_page.reactivate_subscription',
        modalText: 'settings:subscription_invoices_page.reactivate_subscription_confirmation',
        apiEndpoint: CANCEL_SUBSCRIPTION_CANCELLATION
    },
    is_waiting_for_downgrade: {
        title: 'settings:subscription_invoices_page.cancel_downgrade',
        modalText: 'settings:subscription_invoices_page.cancel_downgrade_confirmation',
        apiEndpoint: CANCEL_SUBSCRIPTION_DOWNGRADE
    }
} as const;

export type SubscriptionStateType = (typeof subscriptionStates)[keyof typeof subscriptionStates];
